var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import React, { useRef } from 'react';
import styles from './StyledPrompt.module.css';
export function StyledPrompt(props) {
    var allowOverFlow = props.allowOverFlow, otherProps = __rest(props, ["allowOverFlow"]);
    var portalRef = useRef(document.getElementById('menu-portal'));
    return (React.createElement(Dialog, __assign({}, otherProps, { onClick: function (e) { return e.stopPropagation(); }, onClose: props.onCancel, disableBackdropClick: true, container: portalRef.current, maxWidth: 'sm', classes: {
            paperScrollPaper: allowOverFlow ? styles.allowOverflow : '',
            paperWidthSm: styles.smallWidth
        } }),
        props.title && (React.createElement(DialogTitle, { disableTypography: true },
            React.createElement(Typography, { variant: 'h6', className: styles.title }, props.title))),
        props.onCancel && (React.createElement(IconButton, { title: 'Close', className: styles.closeButton, onClick: props.onCancel, color: 'inherit' },
            React.createElement(Close, null))),
        React.createElement(DialogContent, { classes: {
                root: props.allowOverFlow ? styles.allowOverflow : ''
            } }, props.children),
        React.createElement(DialogActions, { classes: {
                root: styles.dialogActions
            } }, props.actions)));
}
